import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'fitscovery-ui-markdown-viewer',
  templateUrl: './ui-markdown-viewer.component.html',
  styleUrls: ['./ui-markdown-viewer.component.scss']
})
export class UiMarkdownViewerComponent implements OnInit {
  @Input() content: string;

  constructor() { }

  ngOnInit(): void {
  }

}
